import { render, staticRenderFns } from "./viewStaffServices.vue?vue&type=template&id=20cf4910&"
import script from "./viewStaffServices.vue?vue&type=script&lang=js&"
export * from "./viewStaffServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cf4910')) {
      api.createRecord('20cf4910', component.options)
    } else {
      api.reload('20cf4910', component.options)
    }
    module.hot.accept("./viewStaffServices.vue?vue&type=template&id=20cf4910&", function () {
      api.rerender('20cf4910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/viewStaffServices.vue"
export default component.exports